import React, { Component } from 'react'
import Header from '../../Components/header/index.jsx'
import Footer from '../../Components/Footer/index'
import './index.scss'
class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|科技创新'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="zhuanliContent"></div>
        <div className="zhuanli-details">
          <div className="zhuanli-details-title">
            <div className="zhuanli-details-title-h1">
              发明专利
              <div className="zhuanli-details-title-h1-border"></div>
            </div>
          </div>
          <div className="zhuanli-details-content">近年来，公司深耕细作厚积薄发，由我司自主研发“一种便携的水位监测仪”、“一种便于装卸的温湿度传感器”、“一种方便安装的水 位监测仪”、“一种高清度远程温度监测仪”已取得了中华人民共和国国家知识产权局颁发的实用新型专利证书。</div>
          <div className="zhuanli-details-img">
            <img style={{ marginRight: '0.8rem' }} className="zhuanli-details-img-item" src={require('../../image/zhuanli1.png')}></img>
            <img className="zhuanli-details-img-item" src={require('../../image/zhuanli2.png')}></img>
            <img style={{ marginRight: '0.8rem' }} className="zhuanli-details-img-item" src={require('../../image/zhuanli3.png')}></img>
            <img className="zhuanli-details-img-item" src={require('../../image/zhuanli4.png')}></img>
          </div>
        </div>

        <div className="zhuanli-imageul"> </div>

        <Footer></Footer>
      </div>
    )
  }
}

export default index
